/**
 * Planning Capacity API Client (Epic D-1 — Fundament, Story D-1.3)
 *
 * AD-9: `lib/<resource>Api.ts`-conventie, zelfde vorm als
 * `qualificationsApi.ts`. Praat met de capaciteitsroutes van Story D-1.2
 * (`/api/v1/planning/capacity`): het dagcijfer per medewerker en de
 * organisatiebrede wegingsfactor per activiteit.
 */

import { apiRequest } from './api';
import type {
  ActivityWeightDTO,
  ActivityWeightEntryDTO,
  PlanningCapacityDTO,
  PlanningCapacityEntryDTO,
  PlanningTaskActivity,
} from '@functieloonhuis/shared';

interface DataResponse<T> {
  data: T;
}

export const planningCapacityApi = {
  /** GET /planning/capacity — het dagcijfer van élke medewerker, standaardwaarde al ingevuld. */
  listCapacity: async (): Promise<PlanningCapacityEntryDTO[]> => {
    const res = await apiRequest<DataResponse<PlanningCapacityEntryDTO[]>>('/planning/capacity');
    return res.data;
  },

  /** PUT /planning/capacity/:employeeId — body `{ dailyScore }`. */
  updateDailyScore: async (
    employeeId: number,
    dailyScore: number
  ): Promise<PlanningCapacityDTO> => {
    const res = await apiRequest<DataResponse<PlanningCapacityDTO>>(
      `/planning/capacity/${employeeId}`,
      {
        method: 'PUT',
        body: JSON.stringify({ dailyScore }),
      }
    );
    return res.data;
  },

  /** GET /planning/capacity/weights — altijd alle zes activiteiten. */
  listActivityWeights: async (): Promise<ActivityWeightEntryDTO[]> => {
    const res = await apiRequest<DataResponse<ActivityWeightEntryDTO[]>>(
      '/planning/capacity/weights'
    );
    return res.data;
  },

  /** PUT /planning/capacity/weights/:activity — body `{ weight }`. */
  updateActivityWeight: async (
    activity: PlanningTaskActivity,
    weight: number
  ): Promise<ActivityWeightDTO> => {
    const res = await apiRequest<DataResponse<ActivityWeightDTO>>(
      `/planning/capacity/weights/${activity}`,
      {
        method: 'PUT',
        body: JSON.stringify({ weight }),
      }
    );
    return res.data;
  },
};
